var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDefaultAvatarN = function SvgDefaultAvatarN(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 55.3c3.4 0 5.7-.4 5.7-1.6 0-.9-.9-1.2-3.2-1.3-.8-.2-.9-2-.9-4.5v-9.6c0-2.8 0-5 .1-6.5C34.6 35.6 41.5 45 47.5 53c1.2 1.6 2.1 2.4 3.2 2.4s1.9-.8 1.9-2.1c0-2.7-.1-6.5-.1-9.3V32.5c0-2.5.2-4.3.8-4.5 2.3-.1 3.2-.4 3.2-1.3 0-1.2-2.3-1.6-5.5-1.6-3.4 0-5.7.5-5.7 1.6 0 .9.9 1.2 3.2 1.3.8.2.9 1.9.9 4.5v9.7c0 2.3 0 3.9-.1 5-3.3-4-10-13.2-14.9-19.2-1.9-2.4-3-2.9-5.4-2.9-2.9 0-5.1.4-5.1 1.6 0 .9 1 1.2 3.2 1.3.6.5.8 2.8.8 5v14.9c0 2.4-.2 4.3-.8 4.5-2.3.1-3.2.5-3.2 1.3 0 1.2 2.3 1.6 5.6 1.6z"
  })));
};
export default SvgDefaultAvatarN;